<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...$$props}
  ><path
    fill="currentColor"
    d="M1.262 12a3.75 3.75 0 0 1 3.75-3.75h2.25l6-4.5v16.5l-6-4.5h-2.25A3.75 3.75 0 0 1 1.262 12ZM21.784 8.148l.955.955L19.841 12l2.898 2.898-.955.955-2.897-2.898-2.898 2.898-.955-.955L17.932 12l-2.898-2.897.955-.955 2.898 2.898 2.897-2.898Z"
  /></svg
>
